var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === 'function')
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)
            if (e.indexOf(p[i]) < 0)
                t[p[i]] = s[p[i]];
    return t;
};
import isIterable from '../isIterable';
import assign from './assign';
import nodeFactory, { register } from './factory';
import { Size as Padding } from './IPadding';
import Type from './Type';
function isIOptions(init) {
    return typeof init === 'object' && init !== null && !isIterable(init);
}
function options(init) {
    return isIOptions(init) ? init : { children: init };
}
export class Generic {
    constructor(init) {
        this.type = Type.Scrollable;
        const _a = options(init), {padding, children, copy} = _a, rest = __rest(_a, [
                'padding',
                'children',
                'copy'
            ]);
        this.padding = padding || Padding.Normal;
        if (!isIterable(children)) {
            throw TypeError(`Children must be an iterable '${ children }'`);
        }
        this.children = Array.from(children, n => nodeFactory(n, copy));
        const descriptors = Object.getOwnPropertyDescriptors(this);
        descriptors.type.configurable = false;
        descriptors.type.writable = false;
        descriptors.padding.configurable = false;
        descriptors.children.configurable = false;
        Object.defineProperties(this, descriptors);
        assign(this, copy, Object.assign({}, rest));
    }
}
export class Scrollable extends Generic {
}
export const klass = Scrollable;
export default Scrollable;
register(Type.Scrollable, Scrollable);    //# sourceMappingURL=Scrollable.js.map
